/**
 * ページ読み込み時のイベント設定
 */
window.announcement_base_event_set = function () {

    // 詳細画面
    $(document).on('click', '[data-detail-modal]', function () {
        _modal.create(this, 'detail-modal', ['id']);
        return false;
    });

    // 設定画面
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id']);
    });

    // 削除画面
    $(document).on('click', '[data-confirm-modal]', function () {
        _modal.create(this, 'confirm-modal', ['id']);
    });
}

/**
 * 設定モーダル表示時のイベント設定
 */
window.announcement_base_setting_event_set = function () {

    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal');
    });

    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal');
    });
}

